/**
 * NOT-001C1A · URL contract for the Operations Notification Centre.
 *
 * Kept as a pure standalone module so focused static tests can
 * exercise the tab-switch behaviour without booting React /
 * react-router / SWR / the entire Notification Centre page.
 *
 * Shared filters survive a manual tab switch. Everything else —
 * tab-specific filter parameters, `event` / `delivery` detail
 * parameters, `page` — is cleared to keep the URL, selected tab
 * and visible controls in perfect agreement.
 */

export const SHARED_FILTER_KEYS = [
    "since", "until", "customer_id", "project_id", "correlation_id", "q",
];

/**
 * Build a NEW `URLSearchParams` for a manual tab switch.
 *
 * @param {URLSearchParams|string} current - existing URL params.
 * @param {"events"|"deliveries"} nextTab - the target tab.
 * @returns {URLSearchParams} params with only `tab`, `page=1` and
 *   the shared filters that were present on the incoming URL.
 */
export function buildTabSwitchParams(current, nextTab) {
    const src = typeof current === "string"
        ? new URLSearchParams(current)
        : new URLSearchParams(current);
    const p = new URLSearchParams();
    p.set("tab", nextTab);
    for (const k of SHARED_FILTER_KEYS) {
        const v = src.get(k);
        if (v) p.set(k, v);
    }
    p.set("page", "1");
    return p;
}
